import { registerBlockType } from '@wordpress/blocks';
import { addFilter } from '@wordpress/hooks';
import metadata from './block.json';
import Save from './save';
import Edit from './Edit';

const WC_PRODUCT_BLOCKS = [
	'woocommerce/product-image',
	'woocommerce/product-title',
	'woocommerce/product-price',
	'woocommerce/product-rating',
	'woocommerce/product-button',
	'woocommerce/product-badge',
	'woocommerce/product-sale-badge',
	'woocommerce/product-sku',
	'woocommerce/product-stock-indicator',
	'woocommerce/product-summary',
	'woocommerce/product-categories',
	'woocommerce/product-tag-list',
];

addFilter(
	'blocks.registerBlockType',
	'brandy/carousel-allow-wc-blocks',
	( settings, name ) => {
		if ( ! WC_PRODUCT_BLOCKS.includes( name ) ) {
			return settings;
		}
		const ancestor = settings.ancestor ?? [];
		if ( ! ancestor.includes( 'brandy/carousel-slide' ) ) {
			return {
				...settings,
				ancestor: [ ...ancestor, 'brandy/carousel-slide' ],
			};
		}
		return settings;
	}
);

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<path d="M2 4.5C2 3.7 2.7 3 3.5 3h17c.8 0 1.5.7 1.5 1.5v12c0 .8-.7 1.5-1.5 1.5h-17C2.7 18 2 17.3 2 16.5v-12ZM3.5 4.5v12h17v-12h-17Z" />
				<rect x="5" y="6.5" width="5" height="8" rx=".7" />
				<rect x="11" y="6.5" width="5" height="8" rx=".7" opacity=".5" />
				<rect x="17" y="6.5" width="3.5" height="8" rx=".7" opacity=".25" />
				<circle cx="10" cy="20.5" r="1" />
				<circle cx="12" cy="20.5" r="1" opacity=".4" />
				<circle cx="14" cy="20.5" r="1" opacity=".4" />
			</svg>
		),
	},
} );
